import { motion } from 'framer-motion';
import styled from 'styled-components';

import { setTypography, setVh } from 'utils/styles/mixins';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Container = styled(motion.div)`
  width: 100vw;
  min-height: ${setVh(100)};
  height: 100%;
`;

export const ActionButton = styled(motion.button)<{
  isLandingVisible: boolean;
}>`
  position: absolute;
  top: 36rem;
  right: 0rem;
  z-index: 4;
  :focus-visible {
    outline: ${({ isLandingVisible }) =>
        isLandingVisible ? colors.black : colors.white}
      solid 1px;
    outline-offset: 3px;
  }

  svg {
    display: block;
    width: 220rem;
    color: ${({ isLandingVisible }) =>
      isLandingVisible ? colors.taupe : colors.white};
    transition-property: color;
    transition-duration: 0.6s;
  }

  ${mediaTablet`
    top: 110rem;
    right: 32rem;
    svg {
      display: none;
    }
  `}

  ${mediaDesktop`
    top: 110rem;
    right: 92rem;
    svg {
      display: none;
    }
  `}
`;

export const Link = styled(motion.span)<{ isLandingVisible: boolean }>`
  ${({ theme: { locale } }) => setTypography('navigationLink', locale)}
  color: ${({ isLandingVisible }) =>
    isLandingVisible ? colors.taupe : colors.white};
  text-transform: uppercase;
  user-select: none;
  text-align: right;
  cursor: pointer;
  transition-property: color;
  transition-duration: 0.6s;
  display: none;

  ${mediaTablet`
    display: block;
  `}
`;

export const Mask = styled(motion.div)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: ${colors.black};
  user-select: none;
  pointer-events: none;
  z-index: 1;
`;
